// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GaugeCard_wrapper__3dnsJ"};